import { PermIdentity } from '@mui/icons-material';
import { lazy, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Dropdown } from '@ifs-gcp/components';

import { Logout } from './logout';
import styles from './user-dropdown.module.scss';

const LazyLogoutModal = lazy(() => import('./logout-modal/logout-modal'));

export const UserDropdown = () => {
  const { t } = useTranslation();

  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

  const handleCloseLogoutModal = () => {
    setIsLogoutModalOpen(false);
  };

  const MENU_ITEMS = [
    {
      label: t('actions.logout'),
      value: 'logout',
    },
  ];

  const MENU_ELEMENTS: Record<string, React.ReactNode> = {
    logout: <Logout openLogoutModal={() => setIsLogoutModalOpen(true)} />,
  };

  return (
    <>
      <Dropdown
        items={MENU_ITEMS}
        renderDropdownButton={({ onClick }) => (
          <button className={styles.button} onClick={onClick}>
            <PermIdentity />
          </button>
        )}
        renderListElement={(element) => MENU_ELEMENTS[element.value]}
      />
      {isLogoutModalOpen && <LazyLogoutModal onClose={handleCloseLogoutModal} />}
    </>
  );
};
